<template>
  <div id="home">
    <carousel />
    <div class="ivideoframe-container mt-5">
      <iframe class="ivideoframe" src="https://dadeschools.eduvision.tv/EmbedPlayer.aspx?qev=3SfVi13wT7SZUH6M%252fq9A%252fDQQOCUTjbhawAKZHwCFOrFrTFG5jjXKIRN7hFLDL633SQDL%252bQWUvqnr9C8RsU31%252bGkd47wQ%252fev0JSMcdEJxQILp8h0xIpsPgkPRNQOe53mC7%252bxqaVge9oK%252fiZmUJUhyPg%253d%253d"  toolbar="no" scrolling="no" frameborder="0" allowfullscreen="true">
      </iframe></div>
      <b-button variant= "primary" href="https://www.eduvision.tv/l?etgyAyD" target="_blank">Spanish Version</b-button>
      <b-button class="ml-5" variant= "primary" href="https://www.eduvision.tv/l?etgyAyA" target="_blank">Haitian Creole Version</b-button>
    <introduction class="p-3vw" />
    <pillarandPriorities class="mb-5" />
    <objectives class="p-7vw" />
    <!-- <breakdown /> -->
    <!--<call-to-action class="mb-5" title="High quality education is attainable for all students regardless of socio-economic status." description="M-DCPS Teacher" :image="require('@/assets/img/smilingkids2.png')"><span class="sr-only">Alternative image of smiling Children looking at viewer</span></call-to-action> -->
    <call-to-action title="#SecureOurFuture" description="On the November 8, 2022 Ballot!" information="For voting information, visit the Elections Department at miamidade.gov" information2="Find out about upcoming elections, including registration closing dates and candidate qualifying dates." :image="require('@/assets/img/VotingFlag.png')"><span class="sr-only">USA Flag</span></call-to-action>
    <hr class="my-5" />
    <footer-bar />
    <!-- END -->
  </div>
</template>


<script src="https://d1ifvk1tub2sdr.cloudfront.net/Content/js/responsiveembedplayer.js " type="text/javascript"></script>
<script>

import Carousel from "@/views/Home/Carousel";
import Introduction from "@/views/Home/Introduction.vue";
import CallToAction from "@/components/CallToAction.vue";
import Objectives from "@/views/Home/Objectives.vue";
//import Pillars from "@/views/Home/Pillars.vue";
//import Pillarso from "@/views/Home/Pillarso.vue"
//import Breakdown from "@/views/Home/Breakdown.vue";
import PillarandPriorities from "@/views/Home/PillarandPriorities.vue";
import FooterBar from "@/components/FooterBar.vue";

export default {
  name: "Home",
  components: { Carousel, Introduction, CallToAction, Objectives, PillarandPriorities, FooterBar },
  data: () => ({}),
};
</script>
<style scoped>
  iframe {
    height:550px;
    width:970px;
  }
@media screen and (max-width: 1000px){
  iframe{
    height:338px;
    width:601px;
  }
}
@media screen and (max-width: 500px){
  iframe{
    height:200px;
    width:355px;
  }
}
</style>



